const walletSettingPopReducers = (state = false, action) => {
  switch (action.type) {
    case "openWalletSettingPop":
      return (state = true);
    case "closeWalletSettingPop":
      return (state = false);
    default:
      return state;
  }
};
export default walletSettingPopReducers;
